// extracted by mini-css-extract-plugin
export var errorIcon = "_jm-1";
export var nameLogo = "_jm-0";